<template>
  <div class="footer">
    <div class="footer__inner">
      <div class="row w-100">
        <div class="col-12 col-lg-3">
          <logo-footer />
          <span class="d-block my-5 font-weight-lighter" style="font-size: 14px">
            TOO “ASIAPAY” {{ currentYear }} ©
          </span>
          <div class="d-flex mb-5">
            <svg width="24" height="24" class="mt-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM13.664 3.903C12.802 4.245 11.916 4.516 11.007 4.694C10.621 3.423 10.008 2.206 9.166 1.105C11.01 1.417 12.608 2.448 13.664 3.903ZM10.264 10.18C8.762 9.974 7.237 9.974 5.735 10.18C5.427 8.746 5.426 7.262 5.733 5.827C6.479 5.929 7.233 6 8 6C8.767 6 9.52 5.929 10.266 5.827C10.573 7.262 10.572 8.746 10.264 10.18ZM10.005 4.849C8.674 5.021 7.325 5.021 5.994 4.849C6.404 3.563 7.074 2.344 8 1.264C8.926 2.344 9.595 3.563 10.005 4.849ZM6.832 1.105C5.99 2.206 5.378 3.423 4.992 4.694C4.084 4.516 3.198 4.245 2.336 3.903C3.391 2.448 4.989 1.417 6.832 1.105ZM1 8C1 6.834 1.291 5.736 1.797 4.768C2.753 5.161 3.734 5.47 4.743 5.673C4.422 7.21 4.422 8.797 4.744 10.335C3.736 10.536 2.751 10.843 1.797 11.235C1.291 10.265 1 9.167 1 8ZM2.336 12.097C3.198 11.755 4.084 11.484 4.992 11.306C5.378 12.577 5.991 13.794 6.833 14.895C4.989 14.583 3.391 13.552 2.336 12.097ZM5.995 11.151C7.325 10.979 8.674 10.979 10.005 11.151C9.595 12.437 8.925 13.656 8 14.736C7.074 13.656 6.405 12.437 5.995 11.151ZM9.166 14.895C10.008 13.794 10.621 12.577 11.007 11.306C11.915 11.484 12.802 11.756 13.664 12.097C12.608 13.552 11.01 14.583 9.166 14.895ZM11.255 10.333C11.577 8.796 11.578 7.209 11.256 5.672C12.265 5.469 13.247 5.161 14.203 4.767C14.709 5.736 15 6.834 15 8C15 9.167 14.709 10.265 14.203 11.233C13.249 10.842 12.264 10.535 11.255 10.333Z"
                fill="#667481" />
            </svg>
            <select v-model="lang" class="
                form-control form-control-sm
                bg-transparent
                footer__select
                border-0
              " style="margin-top: 2px; font-size: 18px" @change="translate(lang)">
              <option value="kz" class="text-body footer__option">Қазақша</option>
              <option value="ru" class="text-body footer__option">Русский</option>
              <option value="en" class="text-body footer__option">English</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-lg-5">
          <a v-for="(item, i) in footer" :key="i" target="_blank" :href="item.url"
            class="mb-4 d-block small text-decoration-none" v-text="__(`menu.${item.key}`)" />
        </div>

        <div class="col-12 col-lg-3">
          <div class="small pb-4">
            <p v-text="__('menu.address')" />
            <p class="my-4" v-text="__('menu.time')" />
            <a href="tel:+77787463801" class=" text-decoration-none d-block mb-3">+7 (778) 746-38-01</a>
            <a href="tel:+77273441162" class=" text-decoration-none d-block mb-3">+7 (727) 344-11-62</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoFooter from "./icons/LogoFooter.vue";

export default {
  components: {
    LogoFooter,
  },

  data() {
    return {
      lang: localStorage.getItem('lang') || 'ru',
      currentYear: new Date().getFullYear(),
      footer: [
        {
          key: "about",
          url: "https://asiapay.kz/about",
        },
        {
          key: "agreement",
          url: "https://asiapay.kz/terms",
        },
        {
          key: "offer",
          url: "https://asiapay.kz/public_offer",
        },
        {
          key: "rules",
          url: "https://asiapay.kz/rules_payment_organization",
        },
        {
          key: "search",
          url: "https://paycheck.asiapay.kz",
        },
      ],
    };
  },

  methods: {
    translate(lang) {
      this.lang = lang;
      localStorage.setItem("lang", lang);
      location.reload();
    },
  },
};
</script>
<style lang="stylus" scoped>
.footer {
  background-color: #F6F7F7;
  color: #667481;
}
.footer__select{
  color: #667481;
}
.footer__option{
  color: #667481;
}
.footer__inner {
  max-width: 1212px;
  width: 100%;
  margin: 0 auto;
  padding: 95px 24px 80px 24px;
  color: #667481;  
}
a{
  color: #667481;
}
@media (min-width: 768px) and (max-width: 1024px) {
  /* CSS */
  .footer__inner {
    padding: 47px 70px 80px 70px;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  /* CSS */
  .footer__inner {
    padding: 47px 24px 80px 24px;
    }
}
@media (min-width: 320px) and (max-width: 480px) {
  /* CSS */
  .footer__inner {
    padding: 47px 24px 80px 24px;
  }
}
</style>
